import { z } from 'zod';

export const companySchema = z.object({
  idCompany: z.number(),
  Company: z.string(),
  idBusinessForm: z.number(),
  Street: z.string(),
  StreetNr: z.string(),
  StreetAditional: z.string(),
  idPostcode: z.number().nullable(),
  RegisterNumber: z.string().nullable(),
  RegisterCourt: z.string().nullable(),
  TaxNumber: z.string().nullable(),
  SalesTaxNumber: z.string().nullable(),

  PhoneNumber: z.string().optional(),
  Website: z.string().optional(),
  Email: z.string().optional(),

  Postcode: z.string().optional(),
  City: z.string().optional(),
});

export type ICompany = z.infer<typeof companySchema>;

// DKM: Das ist Müll -> .default und dann Parse
export const getNewCompany = (): ICompany => {
  return {
    idCompany: -1,
    Company: '',
    idBusinessForm: 1,
    Street: '',
    StreetNr: '',
    StreetAditional: '',
    idPostcode: null,
    RegisterNumber: null,
    RegisterCourt: null,
    TaxNumber: null,
    SalesTaxNumber: null,
    PhoneNumber: '',
    Website: '',
    Email: '',
    Postcode: '',
    City: '',
  };
};
